const MAX_EXPANDED_PRODUCT_TABLE_ROWS = 15;

export default MAX_EXPANDED_PRODUCT_TABLE_ROWS;
